import {useEffect} from "react";
import {useGetSiteThemeQuery} from "../RTK/Slices/Slices/apiSliceMeat";

/**
 * الألوان الافتراضية - نفس الافتراضي الموجود في الباك اند،
 * بتتطبق فورًا عشان الموقع مايفضلش من غير ألوان لحد ما الطلب يرجع.
 */
const DEFAULTS = {
    header_bg_color: "#c0392b",
    header_text_color: "#ffffff",
    footer_bg_color: "#1a1a1a",
    footer_text_color: "#ffffff",
    site_bg_color: "#f5f0eb",
    category_card_bordered: true,
    category_card_border_color: "#e0e0e0",
    category_card_bg_color: "#ffffff",
    product_card_bg_color: "#ffffff",
    bottom_nav_bg_color: "#c0392b",
    bottom_nav_text_color: "#ffffff",
    features_bg_color: "#cb2914",
    features_text_color: "#ffffff",
};

const applyThemeVars = (theme) => {
    const root = document.documentElement;
    root.style.setProperty("--header-bg-color", theme.header_bg_color);
    root.style.setProperty("--header-text-color", theme.header_text_color);
    root.style.setProperty("--footer-bg-color", theme.footer_bg_color);
    root.style.setProperty("--footer-text-color", theme.footer_text_color);
    root.style.setProperty("--site-bg-color", theme.site_bg_color);
    root.style.setProperty(
        "--category-card-border",
        theme.category_card_bordered
            ? `1px solid ${theme.category_card_border_color}`
            : "none"
    );
    root.style.setProperty("--category-card-bg-color", theme.category_card_bg_color);
    root.style.setProperty("--product-card-bg-color", theme.product_card_bg_color);
    root.style.setProperty("--bottom-nav-bg-color", theme.bottom_nav_bg_color || theme.header_bg_color);
    root.style.setProperty("--bottom-nav-text-color", theme.bottom_nav_text_color);
    root.style.setProperty("--features-bg-color", theme.features_bg_color);
    root.style.setProperty("--features-text-color", theme.features_text_color || "#ffffff");
};

const ThemeProvider = ({children}) => {
    const {data} = useGetSiteThemeQuery();

    useEffect(() => {
        // طبق الافتراضي فورًا عشان الموقع ميفضلش من غير ألوان
        applyThemeVars(DEFAULTS);
    }, []);

    useEffect(() => {
        if (data?.data) {
            applyThemeVars({...DEFAULTS, ...data.data});
        }
    }, [data]);

    return children;
};

export default ThemeProvider;
